<template>
  <div>
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t("inventory_batch_list") }}</h4>
        </div>
      </div>
      <div v-if="can('purchase.purchase_entry', 'W')" class="page-btn">
        <router-link to="/batch/create" class="btn btn-added">
          <i class="ti ti-circle-plus me-2 text-white"></i>{{ $t("add_new_batch") }}
        </router-link>
      </div>
    </div>

    <ThemeDataTable
      ref="batchTable"
      table-id="PurchaseBatchTable"
      :fetch-data="fetchBatchesPage"
      :filters="tableFilters"
    >
      <template #default="{ rows }">
        <thead class="thead-light">
          <tr>
            <th>{{ $t("voucher_no") }}</th>
            <th>{{ $t("item_name") }}</th>
            <th>{{ $t("chalan_no") }}</th>
            <th>{{ $t("chalan_date") }}</th>
            <th>{{ $t("supplier_name") }}</th>
            <th>{{ $t("batch_no") }}</th>
            <th>{{ $t("lot_no") }}</th>
            <th>{{ $t("costing_unit_price") }}</th>
            <th>{{ $t("quantity") }}</th>
            <th>{{ $t("total_amount") }}</th>
            <th>{{ $t("in_house_date") }}</th>
            <th>{{ $t("manufacturing_date") }}</th>
            <th>{{ $t("expiry_date") }}</th>
            <th>{{ $t("warehouse_name") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="batch in rows" :key="batch.id">
            <td>{{ batch.voucher_no }}</td>
            <td>
              <div class="d-flex align-items-center">
                <span class="avatar avatar-md me-2">
                  <img
                    v-if="batch.image"
                    :src="$getImageUrl(batch.image)"
                    alt="Item Image"
                  />
                  <span
                    v-else
                    class="avatar-title rounded bg-light text-secondary d-flex align-items-center justify-content-center w-100 h-100"
                  >
                    <i class="ti ti-photo"></i>
                  </span>
                </span>
                <span>{{ batch.item_name }}</span>
              </div>
            </td>
            <td>{{ batch.chalan_no }}</td>
            <td>{{ batch.chalan_date }}</td>
            <td>{{ batch.supplier_name }}</td>
            <td>{{ batch.batch_no }}</td>
            <td>{{ batch.lot_no }}</td>
            <td>{{ batch.costing_unit_price }}</td>
            <td>{{ batch.quantity }}</td>
            <td>{{ batch.total_amount }}</td>
            <td>{{ batch.in_house_date }}</td>
            <td>{{ batch.manufacturing_date }}</td>
            <td>{{ batch.expiry_date }}</td>
            <td>{{ batch.warehouse_name }}</td>
          </tr>
        </tbody>
      </template>
    </ThemeDataTable>
  </div>
</template>

<script>
import { can as canAccess } from "@/helpers/permission";
import apiUrls from '@/urls';
import ThemeDataTable from '@/components/common/ThemeDataTable.vue';

export default {
  components: {
    ThemeDataTable,
  },
  data() {
    return {
      filterOptions: {
        supplier: [],
        warehouse: [],
      },
    };
  },
  computed: {
    tableFilters() {
      return [
        {
          key: 'supplier',
          label: this.$t('supplier_name'),
          options: this.filterOptions.supplier,
        },
        {
          key: 'warehouse',
          label: this.$t('warehouse'),
          options: this.filterOptions.warehouse,
        },
      ];
    },
  },
  methods: {
    async fetchFilterOptions() {
      try {
        const [suppliersRes, warehousesRes] = await Promise.all([
          this.$axios.get(apiUrls.inventory_supplier.get),
          this.$axios.get(apiUrls.inventory_warehouse.get),
        ]);
        this.filterOptions.supplier = (suppliersRes?.data || [])
          .map((s) => s.name)
          .filter(Boolean);
        this.filterOptions.warehouse = (warehousesRes?.data || [])
          .map((w) => w.name)
          .filter(Boolean);
      } catch (error) {
        console.error('Error fetching purchase filter options:', error);
      }
    },

    async fetchBatchesPage({ draw, start, length, search, orderColumn, orderDir, filters }) {
      const params = {
        draw,
        start,
        length,
        'search[value]': search || '',
        'order[0][column]': orderColumn,
        'order[0][dir]': orderDir,
        ...filters,
      };

      const response = await this.$axios.get(apiUrls.inv_batch.get, { params });
      const payload = response.data || {};

      return {
        data: payload.data || [],
        recordsTotal: payload.recordsTotal || 0,
        recordsFiltered: payload.recordsFiltered || 0,
      };
    },

    can(code, requiredLevel) {
      return canAccess(code, requiredLevel);
    },
  },
  created() {
    this.fetchFilterOptions();
  },
};
</script>
